import React from 'react';
import { motion } from 'motion/react';

// With `href`, it is a real link underneath (so search engines can follow it to that
// page), but a normal click still runs onClick in the app. Looks exactly the same.
const GlassButton: React.FC<{
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
  isNight?: boolean;
  isLanding?: boolean;
  href?: string;
}> = ({ onClick, children, className = "", isNight, isLanding, href }) => {
  const cls = `px-5 py-3.5 md:px-8 md:py-6 rounded-2xl transition-all duration-500 flex items-center gap-4 group w-full md:flex-1 cursor-pointer ${
    isLanding ? 'justify-start' : 'justify-center'
  } ${
    isNight
      ? `liquid-glass text-night-ink ${isLanding ? 'liquid-glass-deep' : ''}`
      : 'bg-white/60 hover:bg-white/80 text-black border border-black/10 backdrop-blur-xl shadow-[0_4px_24px_-8px_rgba(0,0,0,0.1)]'
  } ${className}`;
  if (href) {
    return (
      <motion.a
        href={href}
        whileHover={{ scale: 1.02, y: -1 }}
        whileTap={{ scale: 0.98 }}
        onClick={(e: React.MouseEvent) => {
          // A plain click stays in the app; a new-tab click opens the page itself.
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          onClick();
        }}
        className={`${cls} no-underline`}
        style={{ textDecoration: 'none' }}
      >
        {children}
      </motion.a>
    );
  }
  return (
    <motion.button whileHover={{ scale: 1.02, y: -1 }} whileTap={{ scale: 0.98 }} onClick={onClick} className={cls}>
      {children}
    </motion.button>
  );
};

export default GlassButton;
